import EmptyResults from 'components/EmptyResults'
import { Button, Icon } from 'gu-ui-kit'
import { ReactComponent as NoAdvertisersImage } from 'images/illustration/no-advertisers.svg'
import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useRouteMatch } from 'react-router'
import { Link, useHistory, useParams } from 'react-router-dom'
import { Banner } from './subcomponents/Banner'
import { Chart } from './subcomponents/Chart'
import Filters from './subcomponents/Filters'
import WalletHead from './subcomponents/WalletHead'
import WalletsSwitcher from './subcomponents/WalletsSwitcher'
import { useWalletsActions } from 'modules/Finance/Wallets/useWalletsActions'
import { useWallets } from 'modules/Finance/Wallets/useWallets'
import styles from 'modules/Finance/Wallets/Wallets.module.scss'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import Transaction from 'modules/Finance/Wallets/subcomponents/Transaction'
import PromisedPayments from 'modules/Finance/Wallets/subcomponents/PromisedPayments'

const Wallets = () => {
  const { setActiveWalletID, resetTransactions } = useWalletsActions()
  const { t } = useTranslation(['wallets'])
  const pathGen = useGeneratePathI18n()
  const {
    activeWalletID,
    wallets: { data: wallets, loaded },
  } = useWallets()

  const history = useHistory()

  const { walletID } = useParams()
  const matched = useRouteMatch()

  const listMode = useMemo(
    () => (matched.path.includes('/promised-payments') ? 'promised-payments' : 'transactions'),
    [matched],
  )

  useEffect(() => {
    if (!loaded) {
      return
    }

    if (!wallets.length) {
      return
    }

    setActiveWalletID(
      (walletID && wallets?.find(({ id }) => id === +walletID)?.id) || wallets[0].id,
    )
  }, [loaded])

  useEffect(() => {
    if (activeWalletID) {
      const url = pathGen(
        listMode === 'promised-payments'
          ? ROUTES.FINANCE_WALLET_PROMISED_PAYMENTS
          : ROUTES.FINANCE_WALLET,
        { walletID: activeWalletID },
      )

      history.replace(url + history.location.search)
    }
  }, [activeWalletID])

  useEffect(() => resetTransactions(), [listMode])

  const TransactionComponent = useMemo(() => {
    switch (listMode) {
      case 'transactions':
        return Transaction
      case 'promised-payments':
        return PromisedPayments
      default:
        return null
    }
  }, [listMode])

  return (
    <>
      {wallets.length === 0 && loaded ? (
        <EmptyResults
          header={t('transaction.no_history')}
          image={<NoAdvertisersImage />}
          text={t('transaction.start')}
          actionButton={
            <Button
              component={Link}
              size="l"
              variant="primary"
              startIcon={<Icon name="card" />}
              to={pathGen(ROUTES.BILLING_TOP_UP)}
            >
              {t('transaction.fillUp')}
            </Button>
          }
        />
      ) : (
        <div className={styles['wallets']}>
          <WalletsSwitcher />
          <WalletHead listMode={listMode} />
          <Banner className={styles['wallets__banner']} />
          <Filters className={styles['wallets__filters']} listMode={listMode} />
          {listMode === 'transactions' && <Chart className={styles['wallets__chart']} />}
          <TransactionComponent className={styles['wallets__transaction']} />
        </div>
      )}
    </>
  )
}
export default Wallets
